import classNames from "classnames";
import { useFormikContext } from "formik";
import { AppProps } from "../AppProps";

declare interface FieldWrapperProps extends AppProps {
  name: string;
}

export function FieldWrapper({ children, name }: FieldWrapperProps): JSX.Element {
  const { errors } = useFormikContext();

  let error = name in errors ? (errors as any)[name] : undefined;
  return (
    <div>
      <div>
        {children}
      </div>
      {error && <p className="font-bold text-red-600">{error[0].toUpperCase()}{error.slice(1)}</p>}
      {/* Capitalize error message */}
    </div>
  );
}
